var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cat_box"},[_c('div',{staticClass:"cb_address"},[_vm._v("微信公众号：")]),_c('div',{staticClass:"cb_ma"},[_c('img',{attrs:{"src":_vm.staticImg+_vm.comInfo.image}})]),_c('div',{staticClass:"cb_address mt_30"},[_c('div',[_vm._v("地址："+_vm._s(_vm.comInfo.address))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }